import ptBR from "@/i18n/pt_BR/lang/survey.json";
import enUS from "@/i18n/en_US/lang/survey.json";
import esES from "@/i18n/es_ES/lang/survey.json";

export function getCes2Question(scaleType) {
  if (scaleType === 1) {
    return {
      en_US: enUS.new.ces2_question_likert,
      pt_BR: ptBR.new.ces2_question_likert,
      es_ES: esES.new.ces2_question_likert
    };
  }
  return {
    en_US: enUS.new.ces2_question,
    pt_BR: ptBR.new.ces2_question,
    es_ES: esES.new.ces2_question
  };
}

/**
 * Method that return button scale based on max scale (very hard or extremely)
 * @param {question max scale} maxScale
 */
export function getCes2MinButtonScale(maxScale) {
  if (maxScale === 5) {
    return {
      en_US: enUS.textual.very_hard,
      pt_BR: ptBR.textual.very_hard,
      es_ES: esES.textual.very_hard
    };
  }
  return {
    en_US: enUS.textual.extremely_hard,
    pt_BR: ptBR.textual.extremely_hard,
    es_ES: esES.textual.extremely_hard
  };
}

/**
 * Method that return button scale based on max scale (very easy or extremely)
 * @param {question max scale} maxScale
 */
export function getCes2MaxButtonScale(maxScale) {
  if (maxScale === 5) {
    return {
      en_US: enUS.textual.very_easy,
      pt_BR: ptBR.textual.very_easy,
      es_ES: esES.textual.very_easy
    };
  }
  return {
    en_US: enUS.textual.extremely_easy,
    pt_BR: ptBR.textual.extremely_easy,
    es_ES: esES.textual.extremely_easy
  };
}
